import { create } from 'zustand';
import type { NetRole } from '../net/transport';

interface NetSessionState {
  role: NetRole;
  code: string | null;
  /** Total players in the party, including self. */
  playerCount: number;
  /**
   * Bumps on every session change (host / join / leave / teardown). Effects
   * that own per-session resources depend on it to re-initialise — the session
   * starts while the hub scene is already mounted, so a mount-only effect would
   * miss it.
   */
  epoch: number;
  /** Transient user-facing net message (e.g. host disconnected). */
  notice: string | null;
}

interface NetSessionActions {
  applySession: (role: 'host' | 'client', code: string | null) => void;
  setPlayerCount: (n: number) => void;
  setNotice: (notice: string | null) => void;
  clearSession: () => void;
}

export const useNetSessionStore = create<NetSessionState & NetSessionActions>(
  (set) => ({
    role: 'offline',
    code: null,
    playerCount: 0,
    epoch: 0,
    notice: null,

    applySession: (role, code) =>
      set((s) => ({ role, code, playerCount: 1, epoch: s.epoch + 1 })),
    setPlayerCount: (playerCount) => set({ playerCount }),
    setNotice: (notice) => set({ notice }),
    clearSession: () =>
      set((s) => ({
        role: 'offline',
        code: null,
        playerCount: 0,
        epoch: s.epoch + 1,
      })),
  }),
);
